import {combineReducers} from 'redux';
import homeDataStepView from './homeDataStepView';
import calculatorStepView from './calculatorStepView';
import personalDataStepView from './personalDataStepView';
import workDataStepView from './workDataStepView';
import insuranceDataStepView from './insuranceDataStepView';
import bureauValidateNipView from './bureauValidateNipView';
import bureauAskForNipView from './bureauAskForNipView';
import summaryStepView from './summaryStepView';

const uiReducer = combineReducers({
    calculatorStepView,
    homeDataStepView,
    bureauValidateNipView,
    personalDataStepView,
    workDataStepView,
    insuranceDataStepView,
    bureauAskForNipView,
    summaryStepView
});

export default uiReducer;